// extracted by mini-css-extract-plugin
export default {"IntroBackground":"IntroBackground_IntroBackground__pAObK","topShadow":"IntroBackground_topShadow__11xfA"};